(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6627],{

/***/ 31359:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./components/templates/offshore/about-us/index.js + 7 modules
var about_us = __webpack_require__(58542);
;// CONCATENATED MODULE: ./pages/sg/about-us/data.json
var data_namespaceObject = JSON.parse('{"breadcrumbs":[{"uri":"/","title":"Home"},{"uri":"/corporate-secretary","title":"About Us"}],"dataWhoWeServe":[{"image":{"src":"/assets/images/common/about-us/entrepreneours-about_us.png","alt":"entrepreneours","width":279,"height":213},"title":"Entrepreneurs","description":"Materializing your business ideas is no more a challenge. Our expertise in over 18 countries makes it just easy to start your business venture across the globe."},{"image":{"src":"/assets/images/common/about-us/smes-about_us.png","alt":"SMes","width":282,"height":207},"title":"SMEs","description":"Whether looking for business administration outsourcing or expanding your business to new market with little knowledge and time to setup, you can put trust on us to make the process smooth and cost effective."},{"image":{"src":"/assets/images/common/about-us/professional-about_us.png","alt":"intermedia","width":282,"height":213},"title":"Professional Intermediaries","description":"Leveraging our special knowledge of the countries and system capacity can improve your customers\' experience to a whole new level.","link":{"summary":"Click to know more about our Partner program.","url":"become-our-partner"}}],"dataWhyMakeUs":[{"icon":{"src":"/assets/icons/user-headset.svg","altText":"user-headset"},"title":"Local Knowledge","description":"Our local experts with many years serving customers allow us to gain a full understanding in legal and regulatory compliance necessary for company operation"},{"icon":{"src":"/assets/icons/sliders-h.svg","altText":"sliders-h"},"title":"Tailored Solutions","description":"We can provide customized solutions in line with your business objectives"},{"icon":{"src":"/assets/icons/wallet.svg","altText":"wallet"},"title":"Affordable Pricing","description":"Utilizing technology like cloud computing, saas and outsourced labor force with redundant and repetitive tasks gave us great cost advantage which are passed directly to your benefit"},{"icon":{"src":"/assets/icons/document.svg","altText":"document"},"title":"Range of Services","description":"We can serve as your single point of contact regarding business administration thanks to our wide range of services coverage"}],"dataOurCoreValues":{"title":"Our Core Values","description":"These values are reinforced in day-to-day operation and remain at the heart in setting our strategy to achieve long term goals. It governs and shapes internal interactions throughout the company and relationships with outside stakeholders.","data":{"image":{"src":"/assets/images/common/about-us/statistical-about_us.png","altText":"statistical","width":565,"height":534},"values":[{"icon":{"src":"/assets/icons/hand-check.svg","altText":"hand-check"},"title":"Integrity","description":"We promote truth and honest in our working environment and in dealing with customers, suppliers and other stakeholders."},{"icon":{"src":"/assets/icons/hand-heart.svg","altText":"hand-heart"},"title":"Passion","description":"We take pride in all we do. It lies behind the motivation that keep our job to the highest standard."},{"icon":{"src":"/assets/icons/people-group.svg","altText":"people-group"},"title":"Commitment","description":"Our Dedication & Commitment to customer success with hard & smart working."},{"icon":{"src":"/assets/icons/people-flag.svg","altText":"people-flag"},"title":"Leadership","description":"Ownership and empowerment encourage our employees to become leading in the industry and deliver excellent services."}]}}}');
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/sg/about-us/index.js
/* eslint-disable react/no-unknown-property */






var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Layout/* default */.Z, {
      locationRouter: "sg",
      page: data.page,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(head["default"], {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("link", {
          rel: "alternate",
          href: "".concat("https://betasgo.bbcincorp.com", "/hk/about-us"),
          hreflang: "en-hk"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
          rel: "alternate",
          href: "".concat("https://betasgo.bbcincorp.com", "/sg/about-us"),
          hreflang: "en-sg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
          rel: "alternate",
          href: "".concat("https://betasgo.bbcincorp.com", "/offshore/about-us"),
          hreflang: "en-us"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
          rel: "alternate",
          href: "".concat("https://betasgo.bbcincorp.com", "/offshore/about-us"),
          hreflang: "en"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
          rel: "alternate",
          href: "".concat("https://betasgo.bbcincorp.com", "/vn/about-us"),
          hreflang: "en-vi"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(about_us/* default */.Z, {
        dataJson: data_namespaceObject
      })]
    })
  });
}

/***/ }),

/***/ 89700:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sg/about-us",
      function () {
        return __webpack_require__(31359);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9593,8352,4090,9738,7447,8542,9774,2888,179], function() { return __webpack_exec__(89700); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);